/**
 * Convierte un string a Title Case (Jefferson Martinez Castillo)
 * @param {string} str - El string a convertir
 * @returns {string} El string convertido
 */
export const toTitleCase = (str) => {
  if (!str) return '';
  
  // Lista de palabras que deben permanecer en minúsculas (preposiciones, artículos, etc.)
  // Solo se aplicará si no es la primera palabra
  const exceptions = ['de', 'del', 'la', 'las', 'los', 'y', 'e', 'en', 'con', 'por'];
  
  return str
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .map((word, index) => {
      if (index > 0 && exceptions.includes(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

export default {
  toTitleCase
};
